import React, { useState, useEffect } from "react";

export default function ToggleableNotamList({ airportCode, notams = [], label = "NOTAMs" }) {
  const [showRaw, setShowRaw] = useState(false);
  const [rawNotams, setRawNotams] = useState([]);
  const [loadingRaw, setLoadingRaw] = useState(false);
  const [rawError, setRawError] = useState(null);

  const decoded = notams; // 🔥 just use raw NOTAMs directly

  const [showDecoded, setShowDecoded] = useState(false);

  useEffect(() => {
    if (showRaw && airportCode) {
      fetchRawNotams();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showRaw]);

  const fetchRawNotams = async () => {
    setLoadingRaw(true);
    setRawError(null);
    try {
      const res = await fetch(`/get_raw_notams?airport=${airportCode}`);
      const data = await res.json();

      if (res.ok && Array.isArray(data.raw)) {
        setRawNotams(data.raw);
      } else {
        setRawNotams([]);
        setRawError(data.error || "No raw NOTAMs found.");
      }
    } catch (err) {
      setRawNotams([]);
      setRawError("");
    } finally {
      setLoadingRaw(false);
    }
  };

  if (!notams.length && !showRaw) return null;

  return (
    <div className="notam-toggle-box" style={{ marginTop: 20 }}>
      <div
        className="notam-toggle-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 8,
        }}
      >
        <h3 style={{ fontSize: "16px", fontWeight: "bold" }}>
          {label} for {airportCode}
        </h3>
        <button
  onClick={() => setShowDecoded(!showDecoded)}
  style={{
    padding: "4px 10px",
    background: "rgba(255,255,255,0.07)",
    border: "1px solid #ccc",
    borderRadius: 6,
    fontSize: "12px",
    cursor: "pointer",
    color: "#fff",
    marginRight: 8
  }}
>
  {showDecoded ? "Hide NOTAMs" : "Show NOTAMs"}
</button>
        <button
          onClick={() => setShowRaw(!showRaw)}
          style={{
            padding: "4px 10px",
            background: "rgba(255,255,255,0.07)",
            border: "1px solid #ccc",
            borderRadius: 6,
            fontSize: "12px",
            cursor: "pointer",
            color: "#fff"   // 🔥 THIS LINE
          }}
        >
          {showRaw ? "🔁 View All NOTAMs" : "📝 Show Raw NOTAMs"}
        </button>
      </div>

      <div className="notam-list" style={{ paddingLeft: 10 }}>
        {showRaw ? (
          loadingRaw ? (
            <div style={{ color: "#aaa", fontStyle: "italic" }}>⏳ Fetching NOTAMs from FAA...</div>
          ) : rawError ? (
            <div style={{ color: "#f88", fontStyle: "italic" }}>{rawError}</div>
          ) : rawNotams.length > 0 ? (
            rawNotams.map((text, idx) => (
              <div key={idx} style={{ marginBottom: 10 }}>
                <div style={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>{text}</div>
              </div>
            ))
          ) : (
            <div style={{ color: "#aaa", fontStyle: "italic" }}>
              
            </div>
          )
        ) : showDecoded && decoded.length > 0 ? (
            decoded.map((n, idx) => (
              <div key={idx} style={{ marginBottom: 10 }}>
                <div style={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                  {n.text}
                </div>

                {n.start && n.end && (
                  <div style={{ fontSize: "12px", color: "#aaa" }}>
                    {n.start} → {n.end}
                  </div>
                )}
              </div>
            ))
        ) : (
          <div style={{ color: "#aaa", fontStyle: "italic" }}>
            
          </div>
        )}
      </div>
    </div>
  );
}
